import { ECampaignPosition, ECampaignType, EPopupButtonAction, EPopupDisplayFrequency } from './interfaces.js';
export const CAMPAIGN_TYPE_OPTIONS = [
    { value: ECampaignType.POPUP, label: 'Popup' },
    { value: ECampaignType.GREETING_BAR, label: 'Greeting Bar' },
    { value: ECampaignType.SLIDE_IN, label: 'Slide-in' },
];
export const CAMPAIGN_POSITION_OPTIONS = {
    [ECampaignType.POPUP]: [],
    [ECampaignType.GREETING_BAR]: [
        { value: ECampaignPosition.TOP, label: 'Top' },
        { value: ECampaignPosition.BOTTOM, label: 'Bottom' },
    ],
    [ECampaignType.SLIDE_IN]: [
        { value: ECampaignPosition.BOTTOM_RIGHT, label: 'Bottom Right' },
        { value: ECampaignPosition.BOTTOM_LEFT, label: 'Bottom Left' },
    ],
};
export const getCampaignType = (campaign) => {
    return campaign.campaignType ?? ECampaignType.POPUP;
};
export const isValidCampaignPosition = (campaignType, position) => {
    if (campaignType === ECampaignType.POPUP) {
        return position === undefined;
    }
    return CAMPAIGN_POSITION_OPTIONS[campaignType].some((option) => {
        return option.value === position;
    });
};
export const POPUP_DISPLAY_FREQUENCY_OPTIONS = [
    { value: EPopupDisplayFrequency.ONCE_ONLY, label: 'Once Only' },
    { value: EPopupDisplayFrequency.ONCE_PER_SESSION, label: 'Once Per Session' },
    { value: EPopupDisplayFrequency.EVERY_PAGE_VISIT, label: 'Every Page Visit' },
];
export const POPUP_BUTTON_ACTION_OPTIONS = [
    { value: EPopupButtonAction.CLOSE_ONLY, label: 'Close Only' },
    { value: EPopupButtonAction.INTERNAL_LINK, label: 'Internal Link' },
    { value: EPopupButtonAction.EXTERNAL_LINK, label: 'External Link' },
];
export const POPUP_ACTION_PLACEHOLDERS = {
    [EPopupButtonAction.CLOSE_ONLY]: '',
    [EPopupButtonAction.INTERNAL_LINK]: '/dashboard',
    [EPopupButtonAction.EXTERNAL_LINK]: 'https://example.com',
};
export const CAMPAIGN_AUTO_CLOSE_DEFAULT_SECONDS = 15;
export const POPUP_STORAGE_KEYS = {
    ONCE_ONLY: 'hulyo_popups_once_only',
    ONCE_PER_SESSION: 'hulyo_popups_once_per_session',
};
//# sourceMappingURL=popup-constants.js.map